import { render, staticRenderFns } from "./SpuSetting.vue?vue&type=template&id=695d9f0c"
import script from "./SpuSetting.vue?vue&type=script&lang=js"
export * from "./SpuSetting.vue?vue&type=script&lang=js"
import style0 from "./SpuSetting.vue?vue&type=style&index=0&id=695d9f0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports